function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.6666 0 0 2.6666 .0006536 .0006536)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "translate(4,14)",
  cx: 1.5,
  cy: 1.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 3h-14a4.951 4.951 0 0 0-5 5v8a4.951 4.951 0 0 0 5 5h14a4.951 4.951 0 0 0 5-5v-8a4.951 4.951 0 0 0-5-5zm-14 2h14a2.946 2.946 0 0 1 3 3h-20a2.946 2.946 0 0 1 3-3zm14 14h-14a2.946 2.946 0 0 1-3-3v-6h20v6a2.946 2.946 0 0 1-3 3z"
}));
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.1009796b.svg";
export { ForwardRef as ReactComponent };